module.exports = __webpack_public_path__ + "assets/img/2ce600bcda49b983ad92cb59a273890f.svg";